import heroSlidePortalPaciente from '../images/hero-slide-portal-paciente.jpg';
import heroSlideHospital from '../images/hero-slide-hospital.jpg';
import heroSlideValorDiferencial from '../images/hero-slide-valor-diferencial.jpg';
import heroSlideSenaIdentidad from '../images/hero-slide-sena-identidad.jpg';
import heroSlideTecnologia from '../images/hero-slide-tecnologia.jpg';
import heroSlideNuevaWeb from '../images/hero_equipo_nueva_web_hospital.png';

export interface HeroButton {
  id: string;
  label: string;
  href: string;
  variant?: 'primary' | 'secondary'; // Estilo del botón
}

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  image: string; // Base64 o URL
  imageFileName: string;
  order: number;
  status: 'published' | 'draft';
  // Posición y zoom de la imagen
  imageOffsetX: number; // -100 a 100 (porcentaje)
  imageOffsetY: number; // -100 a 100 (porcentaje)
  imageScale: number; // 1 a 2 (zoom)
  // Botones del slide
  buttons: HeroButton[];
  createdAt: number;
  updatedAt: number;
}

/**
 * Slides estáticos por defecto del carrusel del home
 */
export const defaultHeroSlides: HeroSlide[] = [
  {
    id: 'static_nueva-web',
    title: 'Solimat estrena una nueva web más moderna, accesible y centrada en las personas',
    subtitle:
      'Una plataforma renovada para facilitar el acceso a la información y mejorar la navegación.',
    image: heroSlideNuevaWeb,
    imageFileName: 'hero_equipo_nueva_web_hospital.png',
    order: 1,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [{ id: 'btn-1', label: 'Ver noticia', href: '/noticias/29', variant: 'primary' }],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'static_portal-paciente',
    title: 'Mejoramos la experiencia del Portal del Paciente',
    subtitle: 'Utilizarlo te resultará más sencillo e intuitivo.',
    image: heroSlidePortalPaciente,
    imageFileName: 'hero-slide-portal-paciente.jpg',
    order: 2,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [
      { id: 'btn-1', label: 'Asóciate con nosotros', href: '/para-empresa', variant: 'primary' },
      { id: 'btn-2', label: 'Asistencia Sanitaria', href: '/asistencia-sanitaria', variant: 'secondary' },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'static_hospital',
    title: 'Único hospital laboral en Castilla-La Mancha',
    subtitle: 'Abierto 24 horas los 365 días del año.',
    image: heroSlideHospital,
    imageFileName: 'hero-slide-hospital.jpg',
    order: 3,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [
      { id: 'btn-1', label: 'Asóciate con nosotros', href: '/para-empresa', variant: 'primary' },
      { id: 'btn-2', label: 'Asistencia Sanitaria', href: '/asistencia-sanitaria', variant: 'secondary' },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'static_valor-diferencial',
    title: 'Nuestro valor diferencial',
    subtitle:
      'Grandes profesionales del sector sanitario y de gestión, comprometidos con el mejor servicio.',
    image: heroSlideValorDiferencial,
    imageFileName: 'hero-slide-valor-diferencial.jpg',
    order: 4,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [
      { id: 'btn-1', label: 'Asóciate con nosotros', href: '/para-empresa', variant: 'primary' },
      { id: 'btn-2', label: 'Asistencia Sanitaria', href: '/asistencia-sanitaria', variant: 'secondary' },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'static_sena-identidad',
    title: 'Nuestra seña de identidad',
    subtitle:
      'La cercanía y el trato personalizado con empresarios, trabajadores, autónomos y asesores laborales.',
    image: heroSlideSenaIdentidad,
    imageFileName: 'hero-slide-sena-identidad.jpg',
    order: 5,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [
      { id: 'btn-1', label: 'Asóciate con nosotros', href: '/para-empresa', variant: 'primary' },
      { id: 'btn-2', label: 'Asistencia Sanitaria', href: '/asistencia-sanitaria', variant: 'secondary' },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
  {
    id: 'static_tecnologia',
    title: 'Últimas tecnologías',
    subtitle: 'Dispositivos de última generación al servicio de la calidad asistencial.',
    image: heroSlideTecnologia,
    imageFileName: 'hero-slide-tecnologia.jpg',
    order: 6,
    status: 'published',
    imageOffsetX: 0,
    imageOffsetY: 0,
    imageScale: 1,
    buttons: [
      { id: 'btn-1', label: 'Asóciate con nosotros', href: '/para-empresa', variant: 'primary' },
      { id: 'btn-2', label: 'Asistencia Sanitaria', href: '/asistencia-sanitaria', variant: 'secondary' },
    ],
    createdAt: Date.now(),
    updatedAt: Date.now(),
  },
];
